/**
 * gallery-slideshow ブロック用: 親ブロック(gallery-slideshow)の設定を
 * 子ブロック(gallery-slideshow-image)のマークアップへ反映する。
 *
 * Shopify ではネストブロックが親の block.settings を Liquid から参照できないため、
 * 親が `.content-grid[data-cg-settings]` に出力した設定値を読み取り、
 * 各 `.content-grid-item` のクラス/属性を snippets/gallery-slideshow-image-item.liquid
 * と同じ条件で付け外しする。
 */
(function () {
  if (window.__customGallerySlideshowLoaded) return;
  window.__customGallerySlideshowLoaded = true;

  var ASPECT_RATIO_CLASSES = [
    'content-grid-item__aspect-ratio--natural',
    'content-grid-item__aspect-ratio--square',
    'content-grid-item__aspect-ratio--tall',
    'content-grid-item__aspect-ratio--wide',
    'content-grid-item__aspect-ratio--circle',
  ];

  function isTrue(value) {
    return value === 'true' || value === true;
  }

  function toggleClass(el, className, on) {
    if (!el) return;
    el.classList.toggle(className, on);
  }

  function toggleAttr(el, attr, on) {
    if (!el) return;
    if (on) {
      el.setAttribute(attr, '');
    } else {
      el.removeAttribute(attr);
    }
  }

  function applyButtonStyle(item, buttonsStyle) {
    var wrapper = item.querySelector('.content-grid-item__button');
    if (!wrapper) return;
    var btn = wrapper.querySelector('a, button');
    if (!btn) return;

    btn.classList.remove('btn', 'btn--secondary', 'btn--underlined');
    wrapper.classList.remove('text-link-animated');

    if (buttonsStyle === 'outlined') {
      btn.classList.add('btn', 'btn--secondary');
    } else if (buttonsStyle === 'underlined') {
      btn.classList.add('btn--underlined');
      wrapper.classList.add('text-link-animated');
    } else {
      btn.classList.add('btn');
    }
  }

  function applyItem(item, cfg) {
    var content = item.querySelector('.content-grid-item__content');
    var imageWrap = item.querySelector('.content-grid-item__image');
    var overlay = item.querySelector('.content-grid-item__overlay');
    var text = item.querySelector('.content-grid-item__text');
    var subheading = item.querySelector('.content-grid-item__subheading');
    var heading = item.querySelector('.content-grid-item__heading');
    var button = item.querySelector('.content-grid-item__button');

    var hasButton = !!button;
    var hasHeadingText = !!(subheading || heading);

    // 角丸 (borders): remove_spacing が無効 かつ circle 以外
    if (content) toggleClass(content, 'block-radius-clip', cfg.borders);
    if (imageWrap) toggleClass(imageWrap, 'block-radius', cfg.borders);
    if (imageWrap) {
      imageWrap.querySelectorAll('img, svg').forEach(function (el) {
        toggleClass(el, 'block-radius', cfg.borders);
      });
    }

    // 画像比率 (image_shape)
    if (imageWrap) {
      ASPECT_RATIO_CLASSES.forEach(function (cls) {
        imageWrap.classList.remove(cls);
      });
      imageWrap.classList.add('content-grid-item__aspect-ratio--' + cfg.imageShape);
    }

    // ホバー時アニメ (content)
    if (content) {
      // ズームは画像下テキスト時は無効
      if (cfg.textPositionDesktop === 'below') {
        toggleAttr(content, 'data-animate-hover-zoom', false);
      }
      // ホバー反転は show_on_hover かつ 画像下テキスト以外
      toggleAttr(
        content,
        'data-animate-hover',
        cfg.showOnHover && cfg.textPositionDesktop !== 'below'
      );
    }

    // オーバーレイ表示有無 (両方の位置が画像下なら非表示)
    if (overlay) {
      overlay.style.display = cfg.hasOverlayedContent ? '' : 'none';
    }

    // show-on-hover クラス (show_on_hover 設定を反映)
    toggleClass(overlay, 'content-grid-item__show-on-hover', cfg.showOnHover);
    toggleClass(text, 'content-grid-item__show-on-hover', cfg.showOnHover);

    // テキスト位置 (below)
    toggleClass(text, 'content-position--below', cfg.textPositionDesktop === 'below');

    // ホバーでボタン表示
    toggleClass(
      text,
      'content-grid-item__text--reveal-btn-on-hover',
      cfg.revealButtonOnHover && hasButton && hasHeadingText
    );

    // 見出し/サブ見出し/ボタンのホバーアニメ属性
    toggleAttr(subheading, 'data-animate-hover-block', cfg.showOnHover);
    toggleAttr(heading, 'data-animate-hover-block', cfg.showOnHover);
    if (button) {
      var btnEl = button.querySelector('a, button');
      toggleAttr(btnEl, 'data-animate-hover-block', cfg.showOnHover);
    }

    // ボタンスタイル
    applyButtonStyle(item, cfg.buttonsStyle);
  }

  function applyContainer(container) {
    var imageShape = container.getAttribute('data-cg-image-shape') || 'natural';
    var showOnHover = isTrue(container.getAttribute('data-cg-show-on-hover'));
    var removeSpacing = isTrue(container.getAttribute('data-cg-remove-spacing'));
    var textPositionDesktop = container.getAttribute('data-cg-text-position-desktop') || '';
    var textPositionMobile = container.getAttribute('data-cg-text-position-mobile') || '';
    var buttonsStyle = container.getAttribute('data-cg-buttons-style') || 'filled';

    var cfg = {
      imageShape: imageShape,
      showOnHover: showOnHover,
      removeSpacing: removeSpacing,
      textPositionDesktop: textPositionDesktop,
      textPositionMobile: textPositionMobile,
      buttonsStyle: buttonsStyle,
      borders: !removeSpacing && imageShape !== 'circle',
      hasOverlayedContent: !(textPositionDesktop === 'below' && textPositionMobile === 'below'),
      revealButtonOnHover: !(textPositionDesktop === 'below' || showOnHover),
    };

    container.querySelectorAll('.content-grid-item').forEach(function (item) {
      applyItem(item, cfg);
    });
  }

  function applyAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.content-grid[data-cg-settings]').forEach(applyContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyAll();
    });
  } else {
    applyAll();
  }

  // テーマエディタでの設定変更/再読み込みに対応
  document.addEventListener('shopify:section:load', function (e) {
    applyAll(e.target);
  });
  document.addEventListener('shopify:block:select', function () {
    applyAll();
  });
})();
